/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "user_camera";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface CompensationMode {
}

export enum CompensationMode_Enum {
  COMP_MODE_0 = 0,
  COMP_MODE_05 = 5,
  COMP_MODE_10 = 10,
  COMP_MODE_15 = 15,
  COMP_MODE_20 = 20,
  COMP_MODE_25 = 25,
  COMP_MODE_30 = 30,
  COMP_MODE_N05 = -5,
  COMP_MODE_N10 = -10,
  COMP_MODE_N15 = -15,
  COMP_MODE_N20 = -20,
  COMP_MODE_N25 = -25,
  COMP_MODE_N30 = -30,
  UNRECOGNIZED = -1,
}

export function compensationMode_EnumFromJSON(object: any): CompensationMode_Enum {
  switch (object) {
    case 0:
    case "COMP_MODE_0":
      return CompensationMode_Enum.COMP_MODE_0;
    case 5:
    case "COMP_MODE_05":
      return CompensationMode_Enum.COMP_MODE_05;
    case 10:
    case "COMP_MODE_10":
      return CompensationMode_Enum.COMP_MODE_10;
    case 15:
    case "COMP_MODE_15":
      return CompensationMode_Enum.COMP_MODE_15;
    case 20:
    case "COMP_MODE_20":
      return CompensationMode_Enum.COMP_MODE_20;
    case 25:
    case "COMP_MODE_25":
      return CompensationMode_Enum.COMP_MODE_25;
    case 30:
    case "COMP_MODE_30":
      return CompensationMode_Enum.COMP_MODE_30;
    case -5:
    case "COMP_MODE_N05":
      return CompensationMode_Enum.COMP_MODE_N05;
    case -10:
    case "COMP_MODE_N10":
      return CompensationMode_Enum.COMP_MODE_N10;
    case -15:
    case "COMP_MODE_N15":
      return CompensationMode_Enum.COMP_MODE_N15;
    case -20:
    case "COMP_MODE_N20":
      return CompensationMode_Enum.COMP_MODE_N20;
    case -25:
    case "COMP_MODE_N25":
      return CompensationMode_Enum.COMP_MODE_N25;
    case -30:
    case "COMP_MODE_N30":
      return CompensationMode_Enum.COMP_MODE_N30;
    case -1:
    case "UNRECOGNIZED":
    default:
      return CompensationMode_Enum.UNRECOGNIZED;
  }
}

export function compensationMode_EnumToJSON(object: CompensationMode_Enum): string {
  switch (object) {
    case CompensationMode_Enum.COMP_MODE_0:
      return "COMP_MODE_0";
    case CompensationMode_Enum.COMP_MODE_05:
      return "COMP_MODE_05";
    case CompensationMode_Enum.COMP_MODE_10:
      return "COMP_MODE_10";
    case CompensationMode_Enum.COMP_MODE_15:
      return "COMP_MODE_15";
    case CompensationMode_Enum.COMP_MODE_20:
      return "COMP_MODE_20";
    case CompensationMode_Enum.COMP_MODE_25:
      return "COMP_MODE_25";
    case CompensationMode_Enum.COMP_MODE_30:
      return "COMP_MODE_30";
    case CompensationMode_Enum.COMP_MODE_N05:
      return "COMP_MODE_N05";
    case CompensationMode_Enum.COMP_MODE_N10:
      return "COMP_MODE_N10";
    case CompensationMode_Enum.COMP_MODE_N15:
      return "COMP_MODE_N15";
    case CompensationMode_Enum.COMP_MODE_N20:
      return "COMP_MODE_N20";
    case CompensationMode_Enum.COMP_MODE_N25:
      return "COMP_MODE_N25";
    case CompensationMode_Enum.COMP_MODE_N30:
      return "COMP_MODE_N30";
    case CompensationMode_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseCompensationMode(): CompensationMode {
  return {};
}

export const CompensationMode = {
  encode(_: CompensationMode, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CompensationMode {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCompensationMode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): CompensationMode {
    return {};
  },

  toJSON(_: CompensationMode): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<CompensationMode>, I>>(base?: I): CompensationMode {
    return CompensationMode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CompensationMode>, I>>(_: I): CompensationMode {
    const message = createBaseCompensationMode();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
